import React from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from "@mui/material";

export const ACTIVE_COLOR = "#c3183c";
export const INACTIVE_COLOR = "rgba(0, 0, 0, 0.6)";

interface StyledTextFieldProps {
  value: string;
  type?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  error?: boolean;
  helperText?: string;
  multiline?: boolean;
  placeholder?: string;
  disabled?: boolean;
  inputProps?: any;
  sx?: any;
}

interface StyledSelectProps {
  value: string;
  onChange: any;
  label: string;
  children: React.ReactNode;
  error?: boolean;
  helperText?: string;
}


export function StyledTextField({ value, onChange, label, type = 'text', error, helperText, multiline = false, placeholder="", disabled=false, inputProps, sx, ...rest }: StyledTextFieldProps) {
  const hasValue = Boolean(value);

  return (
    <TextField
      {...rest}
      type={type}
      label={label}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      multiline={multiline}
      rows={multiline ? 4 : 1}
      inputProps={inputProps}
      FormHelperTextProps={{ sx: { marginLeft: '0px' } }}
      InputLabelProps={{
        sx: {
          lineHeight: 1,
          marginTop: value ? '4px' : '-2px',
          color: hasValue ? ACTIVE_COLOR : INACTIVE_COLOR,
          "&.Mui-focused": {
            marginTop: '4px',
            color: ACTIVE_COLOR,
          },
          "&.MuiInputLabel-shrink": {
            color: ACTIVE_COLOR,
          },
          "&:hover": {
            color: ACTIVE_COLOR,
          },
        },
      }}
      InputProps={{
        disabled: disabled,
        sx: {
          height: !multiline ? '40px' : 'auto',
        },
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          "&.Mui-focused fieldset": {
            borderColor: ACTIVE_COLOR,
          },
          "&:hover fieldset": {
            borderColor: ACTIVE_COLOR,
          },
        },
        ...sx
      }}
      fullWidth
    />
  );
}

export function StyledSelect({ value, onChange, label, children, error, helperText, ...rest }: StyledSelectProps) {
  const hasValue = Boolean(value);

  return (
    <FormControl fullWidth>
      <InputLabel
        sx={{
          lineHeight: 1,
          marginTop: hasValue ? '4px' : '-2px',
          color: hasValue ? ACTIVE_COLOR : INACTIVE_COLOR,
          "&.Mui-focused": {
            marginTop: '4px',
            color: ACTIVE_COLOR,
          },
          "&.MuiInputLabel-shrink": {
            color: ACTIVE_COLOR,
          },
          "&:hover": {
            color: ACTIVE_COLOR,
          },
        }}
      >
        {label}
      </InputLabel>
      <Select
        {...rest}
        value={value}
        onChange={onChange}
        label={label}
        error={error}
        sx={{
          height: '40px',
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: ACTIVE_COLOR,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: ACTIVE_COLOR,
          },
        }}
      >
        {children}
      </Select>
      {helperText && (
        <FormHelperText sx={{ marginLeft: '0px', color: '#d32f2f' }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
}
